import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=4f03e585&"
import script from "./IconRefresh.vue?vue&type=script&lang=js&"
export * from "./IconRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f03e585')) {
      api.createRecord('4f03e585', component.options)
    } else {
      api.reload('4f03e585', component.options)
    }
    module.hot.accept("./IconRefresh.vue?vue&type=template&id=4f03e585&", function () {
      api.rerender('4f03e585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRefresh.vue"
export default component.exports